import Api from 'services/api'

const API_SSO_PROVIDERS = '/auth/sso/providers'
const API_SSO_START = '/auth/sso/start'
const API_SSO_EXCHANGE = '/auth/sso/exchange'
const API_ADMIN_SSO_CONFIG = '/admin/sso/config'

export interface SsoProviderOption {
  id: string
  label: string
  vendor: string
}

export interface SsoProvidersResponse {
  allowPasswordLogin: boolean
  /**
   * Password sign-in is off for staff but still open to some account types - brokers and other
   * third parties, who have no account in the company's identity provider. The form has to stay on
   * the page; the server decides whose password it accepts.
   */
  passwordLoginLimited?: boolean
  providers: SsoProviderOption[]
}

/** What the sign-in page may offer. Unauthenticated; returns no secrets. */
export const getSsoProviders = (): Promise<SsoProvidersResponse> => Api.get(API_SSO_PROVIDERS)

/** Begin a sign-in; the caller sends the browser to the URL this returns. */
export const startSso = (providerId: string, redirectTo: string): Promise<{ authorizationUrl: string }> =>
  Api.post(API_SSO_START, { providerId, redirectTo })

/** Trade the single-use code from the callback for a session. */
export const exchangeSsoCode = (code: string): Promise<any> => Api.post(API_SSO_EXCHANGE, { code })

export const getSsoConfig = (): Promise<any> => Api.get(API_ADMIN_SSO_CONFIG)

export const setSsoConfig = (data: any): Promise<any> => Api.post(API_ADMIN_SSO_CONFIG, data)
